<template>
  <div class="photos-combined">
    <p v-if="ids.length === 0" class="error">
      Debes incluir al menos un ID en el parámetro ids.
    </p>

    <iframe
      v-for="id in ids"
      :key="id"
      :src="`/encuestas/fotos?id=${encodeURIComponent(id)}`"
      :title="`Galería ${id}`"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "PhotosCombined",

  computed: {
    ids() {
      const idsParameter = this.$route.query.ids;

      if (!idsParameter) {
        return [];
      }

      return idsParameter
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
    },
  },
};
</script>

<style scoped>
.photos-combined {
  padding: 20px;
}

iframe {
  display: block;
  width: 100%;
  height: 900px;
  margin-bottom: 24px;
  border: 0;
}

.error {
  padding: 16px;
}
</style>
